module.exports = "<!--Footer Starts-->\n<footer>\n    <div class=\"container-fluid\">\n\n    </div>\n</footer>\n<!--Footer Ends-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main